import { HttpStatusCode } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { MESSAGE } from '@shared/constants';

import { AttentionModalComponent } from '../attention-modal/attention-modal.component';

@Component({
  selector: 'app-error-modal',
  templateUrl: 'error-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RktButtonDirective, AttentionModalComponent],
})
export class ErrorModalComponent implements OnInit {
  @Input() messageText = 'We are unable to complete this request. Please contact your administrator.';

  errorType?: string | number;

  modalTitle!: string;

  modalSubTitle!: string;

  btnText!: string;

  constructor(public activeModal: ActiveModal) {}

  ngOnInit() {
    this.modalTitle = this.errorType === 403 ? MESSAGE.PERMISSION_DENIED_TITLE : 'Error';
    this.messageText = this.parseErrorMessage(this.messageText);
    this.btnText = 'Continue';
  }

  modalInitData(data: { modalTitle: string; messageText: string; btnText: string }) {
    const { modalTitle, messageText, btnText } = data;
    this.modalTitle = modalTitle ?? 'Error';
    this.messageText = this.parseErrorMessage(messageText);
    this.btnText = btnText ?? 'Continue';
  }

  parseErrorMessage(messageText: number | string | undefined): string {
    if (messageText && typeof messageText === 'number') {
      switch (messageText) {
        case HttpStatusCode.NotFound:
          return MESSAGE.RESOURCE_NOT_FOUND_ERROR;
        case HttpStatusCode.Unauthorized:
        case HttpStatusCode.Forbidden:
          return MESSAGE.PERMISSION_DENIED;
        default:
          return MESSAGE.UNKNOWN_ERROR;
      }
    } else {
      return messageText?.toString() ?? MESSAGE.UNKNOWN_ERROR;
    }
  }
}
